/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { APIStatus } from '../actions/api';
import { types } from '../actions/register';
import { combineAPIReducers } from './api';

function checkEmailStateCreator(api) {
  const { response, status } = api;

  if (!APIStatus.complete(status)) {
    return {
      status: 'pending',
    };
  }
  if (status === APIStatus.API_FAILURE) {
    return {
      status: 'failure',
      error: {
        code: 'FE_NETWORKFAIL',
        message: 'network failed',
      },
    };
  }
  if (response.available) {
    return {
      status: 'success',
    };
  }
  return {
    status: 'failure',
    error: {
      code: 'FE_EMAILOCCUPIED',
      message: 'email occupied',
    },
  };
}

export default combineAPIReducers(types, {
  checkEmail: checkEmailStateCreator,
});




// WEBPACK FOOTER //
// ./src/redux/reducers/register.js